const softwareUpdateModal = {
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
  templateUrl:
    '/modules/modals/software-update-modal/software-update-modal.html',
  controller: 'SoftwareUpdateModalController',
};

angular
  .module('modalDirectives')
  .component('softwareUpdateModal', softwareUpdateModal);
